import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import InflationCalculator from './InflationCalculator';

const InflationInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Inflation Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Inflation Calculator helps you understand the impact of inflation on your money over time. It provides a quick and accurate assessment of how purchasing power changes due to inflation, helping you make informed financial decisions.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Initial Amount</li>
        <li>Inflation Rate</li>
        <li>Time Period</li>
        <li>Future Value</li>
        <li>Purchasing Power</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses a comprehensive approach to determine the impact of inflation:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculates future value of money considering inflation</li>
        <li>Shows how purchasing power changes over time</li>
        <li>Compares current and future values</li>
        <li>Provides annual inflation impact</li>
        <li>Generates detailed inflation analysis</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Understand real value of money</li>
        <li>Plan long-term investments</li>
        <li>Compare past and future values</li>
        <li>Make informed financial decisions</li>
        <li>Track inflation impact</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your initial amount, desired inflation rate, and time period to calculate the impact of inflation on your money. The calculator will provide a detailed analysis of how your purchasing power changes over time.</p>
    </div>
  );
};

const Inflation = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <InflationCalculator/>
        </div>
        <InflationInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default Inflation;